import { cn } from '@divlab/divanui';

import styles from './SkeletRect.module.css';

import type { FC, PropsWithChildren } from 'react';

export interface SkeletRectProps {
  className?: string;
  theme?: 'light' | 'gray';
}

const SkeletRect: FC<PropsWithChildren<SkeletRectProps>> = (props) => {
  const { className, theme = 'gray', ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.rect,
        { [styles.light]: theme === 'light', [styles.gray]: theme === 'gray' },
        className,
      )}
    ></div>
  );
};

export default SkeletRect;
